
import {createSlice, createSelector} from '@reduxjs/toolkit';
import {FormUserInit} from "./userModel";


// import {INIT} from './../constants/status';

const initialState = {
    users: [],
    userForm: FormUserInit,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUsers: (state, action) => {
            state.users = action.payload;
        },
        onUserFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.userForm[name] = value;
        },
        initUserForm: (state, action) => {
            state.userForm = action.payload;
        },
    },
});

export const {actions} = userSlice;
export const {
    setUsers,
    onUserFormChange,
    initUserForm,
} = actions;

// selectors

export const selUsers = (state) => state.user.users;
export const selUserForm = (state) => state.user.userForm;

const reducer = {
    user: userSlice.reducer,
};
export default reducer;